import { Icon, TextField } from '@atom/mui';
import { CloseIcon, SearchIcon } from '@atom/mui/icons';

const styles = {
  close: {
    cursor: 'pointer',
  },
};

export interface Props {
  assetSearchEnabled: boolean;
  categorySearchEnabled: boolean;
  query: string;
  setQuery: (query: string) => void;
  dataCyPrefix?: string;
}

const SearchInput = ({
  assetSearchEnabled,
  categorySearchEnabled,
  query,
  setQuery,
  dataCyPrefix = '',
}: Props) => (
  <>
    {(assetSearchEnabled || categorySearchEnabled) && (
      <TextField
        value={query}
        onChange={event => setQuery(event.target.value)}
        placeholder={assetSearchEnabled ? 'Search' : 'Search by folder name'}
        data-cy={`${dataCyPrefix}SearchInput`}
        slotProps={{
          input: {
            startAdornment: <Icon icon={SearchIcon} />,
            endAdornment: query && (
              <Icon
                style={styles.close}
                onClick={() => setQuery('')}
                icon={CloseIcon}
              />
            ),
          },
        }}
      />
    )}
  </>
);

export default SearchInput;
